import Link from 'next/link'
import { Join } from '../../lib/utils'

interface ButtonProps {
  href: string
  children: React.ReactNode
  className?: string
  shadow?: boolean
  ariaLabel?: string
  target?: string
  onClick?: () => void
}

export function Button({
  href,
  children,
  className,
  shadow = true,
  ariaLabel,
  target = '_blank',
  onClick,
}: ButtonProps) {
  const baseClasses = Join(
    'inline-flex items-center justify-center rounded-full',
    'px-4 py-2 text-sm font-semibold',
    'transition-all duration-200',
    shadow && 'shadow-sm hover:shadow-md',
    className,
  )

  return (
    <Link
      href={href}
      className={baseClasses}
      aria-label={ariaLabel}
      target={target}
      onClick={onClick}
    >
      {children}
    </Link>
  )
}
